@if (contract().company; as company) {
  <mat-icon svgIcon="icon-dossier" tiimeTooltip="Dossier"></mat-icon>
  <app-company-cell [company]="company"></app-company-cell>
} @else {
  <mat-icon svgIcon="icon-prospect" tiimeTooltip="Prospect"></mat-icon>
  <app-prospect-cell [prospect]="contract().prospect"></app-prospect-cell>
}
